import useDeleteProduct from 'api/productsList/useDeleteProduct/useDeleteProduct';
import useProductsList from 'api/productsList/useProductsList/useProductsList';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import ProductsListEditModal from 'components/shared/Modals/productsList/ProductsListEditModal/ProductsListEditModal';
import ProductsListInsertModal from 'components/shared/Modals/productsList/ProductsListInsertModal/ProductsListInsertModal';
import PageSpinner from 'components/shared/pageSpinner/PageSpinner';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import useProductListTableColumns from 'hooks/productList/useProductListTableColumns';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// last search string
let lastSearch = null;

const ProductList = () => {
  const [page, setPage] = useState(1);

  const [getProductsList, loading, productList, pageRef] = useProductsList();
  const [pageSize, setPageSize] = useState('100');

  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteChosenLocation, setDeleteChosenLocation] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editChosenProduct, setEditChosenProduct] = useState({});

  const [deleteRequest] = useDeleteProduct();
  const navigate = useNavigate();
  const { can } = usePermissions();

  const productListPermissions =
    permissions.general.categories.globalSettings.productManagement.productList;

  const canCreate = can(productListPermissions.create);
  const canDelete = can(productListPermissions.delete);
  const canDetail = can(productListPermissions.detail.view);
  const canEdit = can(productListPermissions.edit);
  const canGraph = can(productListPermissions.graph);

  useEffect(() => {
    getProductsList({ page: 1, count: pageSize });
  }, []);

  useEffect(() => {
    getProductsList({ page, count: pageSize });
  }, [pageSize]);

  const goToGraphPage = useCallback(
    row => () => navigate(`/product-graph/${row.id}`),
    [],
  );

  const goToInfoPage = useCallback(
    row => () => navigate(`/productDetail/${row.id}`),
    [],
  );

  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenLocation(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );

  const editItem = useCallback(
    row => () => {
      setEditChosenProduct(row);
      setIsEditModalOpen(true);
    },
    [],
  );

  const apiRef = useRef(null);
  const [columnsData] = useProductListTableColumns(
    goToInfoPage,
    goToGraphPage,
    deleteItem,
    editItem,
    apiRef,
    {
      canDetail,
      canGraph,
      canEdit,
      canDelete,
    },
  );

  const deleteHandle = id => {
    setDeleteLoading(true);
    deleteRequest(id, getProductsList, setIsDeleteModalOpen, setDeleteLoading);
  };

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getProductsList({ page: pageNumber, count: pageSize, term: lastSearch });
  }

  function handleSearch(text) {
    setPage(1);
    lastSearch = text;
    if (text === '') {
      lastSearch = null;
    }
    getProductsList({ page: 1, count: pageSize, term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      {Object.keys(productList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={productList[page]}
          rows={productList[page]}
          pageSize={pageSize}
          isDeletable={canDelete}
          isLoading={loading}
          addLable={canCreate ? 'ثبت محصول جدید' : undefined}
          onAddClick={canCreate ? () => setIsInsertModalOpen(true) : undefined}
          setPageSize={val => setPageSize(val)}
          apiRef={apiRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
        />
      ) : (
        <PageSpinner loading />
      )}

      {canDelete ? (
        <DeleteModal
          open={isDeleteModalOpen}
          handleClose={() => setIsDeleteModalOpen(false)}
          title={deleteChosenLocation.title}
          locationId={deleteChosenLocation.id}
          deleteLoading={deleteLoading}
          onDelete={deleteHandle}
        />
      ) : null}

      {canEdit ? (
        <ProductsListEditModal
          open={isEditModalOpen}
          handleClose={() => setIsEditModalOpen(false)}
          getProsuctList={getProductsList}
          mainInfo={editChosenProduct}
        />
      ) : null}

      {canCreate ? (
        <ProductsListInsertModal
          open={isInsertModalOpen}
          handleClose={() => setIsInsertModalOpen(false)}
          getProsuctList={getProductsList}
        />
      ) : null}
    </>
  );
};

export default ProductList;
